import { useState } from "react";
import { feedCategories, feedItems } from "@/mocks/suye";
import SectionHeading, { catName } from "./SectionHeading";

export default function LiveFeed() {
  const [active, setActive] = useState("all");
  const list = active === "all" ? feedItems : feedItems.filter((f) => f.categoryId === active);

  return (
    <section id="live" className="border-b border-background-200 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-[1080px] px-4 md:px-6">
        <SectionHeading
          kicker="现场围观"
          title={
            <>
              正在发生的<span className="text-primary-600">热搜现场</span>
            </>
          }
          desc="事件推进到哪里，这里就跟进到哪里。按分类切换，别错过任何一个反转。"
          action={
            <a
              href="#contact"
              className="hidden items-center gap-1.5 rounded-full border border-background-300 px-4 py-2 text-xs font-medium text-foreground-700 transition-colors hover:bg-background-100 md:inline-flex"
            >
              <i className="ri-notification-3-line text-primary-500" />
              开提醒，不落瓜
            </a>
          }
        />

        <div className="mb-7 flex flex-wrap items-center gap-2">
          {feedCategories.map((c) => (
            <button
              key={c.id}
              type="button"
              onClick={() => setActive(c.id)}
              className={
                "whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors " +
                (active === c.id
                  ? "bg-foreground-950 text-background-50"
                  : "bg-background-100 text-foreground-600 hover:bg-background-200")
              }
            >
              {c.name}
              {c.id !== "all" && (
                <span className={"ml-1.5 text-[10px] " + (active === c.id ? "text-background-300" : "text-foreground-400")}>
                  {feedItems.filter((f) => f.categoryId === c.id).length}
                </span>
              )}
            </button>
          ))}
        </div>

        <div className="relative">
          <span aria-hidden className="absolute left-[7px] top-2 bottom-2 w-px bg-background-200 md:left-[9px]" />
          <ul className="space-y-5">
            {list.map((f) => (
              <li key={f.id} className="relative pl-8 md:pl-12">
                <span
                  className={
                    "absolute left-0 top-5 flex h-[15px] w-[15px] items-center justify-center rounded-full ring-4 md:top-6 " +
                    (f.live ? "bg-primary-500 ring-primary-100" : "bg-background-300 ring-background-100")
                  }
                >
                  {f.live && <span className="pulse-dot h-1.5 w-1.5 rounded-full bg-background-50" />}
                </span>
                <article className="group rounded-2xl border border-background-200 bg-background-100/50 p-4 transition-colors hover:border-primary-200 hover:bg-background-100 md:p-5">
                  <div className="flex flex-wrap items-center gap-2">
                    {f.live && (
                      <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-2 py-0.5 text-[10px] font-bold text-primary-700">
                        <span className="pulse-dot h-1.5 w-1.5 rounded-full bg-primary-500" />
                        LIVE 直播中
                      </span>
                    )}
                    <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-[11px] font-medium text-secondary-800">
                      {catName(f.categoryId)}
                    </span>
                    <span className="text-xs text-foreground-400">{f.time}</span>
                  </div>
                  <h3 className="mt-3 font-heading text-lg font-bold leading-snug text-foreground-950 md:text-xl">
                    {f.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{f.summary}</p>
                  <div className="mt-3 flex flex-wrap items-center justify-between gap-3">
                    <div className="flex flex-wrap gap-2">
                      {f.tags.map((tg) => (
                        <span
                          key={tg}
                          className="whitespace-nowrap rounded-md bg-background-200 px-2 py-0.5 text-[11px] text-foreground-600"
                        >
                          #{tg}
                        </span>
                      ))}
                    </div>
                    <div className="flex items-center gap-4 text-xs text-foreground-500">
                      <span className="inline-flex items-center gap-1">
                        <i className="ri-eye-line text-accent-600" /> {f.watch} 围观
                      </span>
                      <span className="inline-flex items-center gap-1">
                        <i className="ri-chat-3-line" /> {f.comments} 评论
                      </span>
                      <span className="inline-flex items-center gap-1 font-medium text-primary-700">
                        <i className="ri-fire-fill" /> {f.heat}
                      </span>
                    </div>
                  </div>
                </article>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}